<template>
  <div class="page-container">
    <!-- Кривая линия -->
    <div class="curve-line" v-if="showCurve">
      <svg class="curve-svg" viewBox="0 0 100 1000" preserveAspectRatio="none">
        <path class="curve-path" d="M50,0 C70,50 30,150 50,200 C70,250 30,350 50,400 C70,450 30,550 50,600 C70,650 30,750 50,800 C70,850 30,950 50,1000" />
      </svg>
    </div>
    
    <section class="silimed">
      <h2 class="section-title animate-element" ref="sectionTitle">{{ $t('main.start')}}</h2>

      <div class="silimed-banner animate-element" ref="silimedBanner">
        <img src="/img/silimed_BTR.jpg" alt="Silimed">
      </div>

      <div class="silimed-buttons animate-element" ref="silimedButtons">
        <a href="#" @click="goToBiodesin">{{ $t('main.bio')}}</a>
        <a href="#" @click="goToStandard">{{ $t('main.stand')}}</a>
        <a href="#" @click="goToType">{{ $t('main.type')}}</a>
      </div>

      <div class="silimed-text animate-element" ref="silimedText">
        <h2>{{ $t('main.silimed')}}</h2>
        <p>{{ $t('main.p')}}</p>
        <p>{{ $t('main.p2')}}</p>
      </div>
    </section>
    
    <section class="features">
      <div class="feature-card animate-element" ref="featureCard1">
        <div class="feature-block-img">
          <img src="/img/icon/f428c25295a49a1295c821e3bae15e2a.png" alt="Гарантия" class="feature-icon">
        </div>
        
        <h3>{{ $t('main.garants') }}</h3>
        <p>{{ $t('main.p3')}}</p>
        <ul>
          <li>{{ $t('main.forever')}}</li>
          <li>{{  $t('main.garant') }}</li>
        </ul>
      </div>

      <div class="feature-card animate-element" ref="featureCard2">
        <div class="feature-block-img-other">
          <img src="/img/icon_main_1.jpg" alt="HSC+" class="feature-icon-other">
        </div>
        
        <h3>{{ $t('maim.gel')}}</h3>
        <ul>
          <li>{{ $t('main.li') }}</li>
          <li>{{ $t('main.li2') }}</li>
          <li>{{ $t('main.li3') }}</li>
          <li>{{ $t('main.li4') }}</li>
          <li>{{ $t('main.li5') }}</li>
        </ul>
        <p>{{ $t('main.gell')}}</p>
      </div>

      <div class="feature-card animate-element" ref="featureCard3">
        <div class="feature-block-img">
          <img src="/img/icon/edb4d5ec7b1b6a408d7397a2e92051ff.png" alt="Формы" class="feature-icon">
        </div>
        
        <h3>{{ $t('main.forms')}}</h3>
        <p>{{ $t('main.types')}}</p>
        <p>{{ $t('main.material')}}</p>
        <p>{{ $t('main.biodesign') }}</p>
      </div>
    </section>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'MainImplants',
  data() {
    return {
      showCurve: true
    }
  },
  
  setup() {
    const router = useRouter()

    function goToBiodesin() {
      router.push("/biodesain")
    }
    function goToStandard() {
      router.push("/standardline")
    }
    function goToType() {
      router.push("/type")
    }

    return { goToBiodesin , goToStandard , goToType }
  },

  mounted() {
    this.initAnimations();
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Проверить сразу при монтировании
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // переключение языка
    switchLang(lang) {
      this.$i18n.locale = lang
    },

    initAnimations() {
      // Активируем анимацию кривой (только если она видна)
      if (this.showCurve) {
        setTimeout(() => {
          const curveLine = document.querySelector('.curve-line');
          if (curveLine) {
            curveLine.classList.add('animate-curve');
          }
        }, 100);
      }
      
      // Функция для проверки видимости элемента
      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
          rect.bottom >= 0
        );
      };
      
      // Функция обработки скролла
      const handleScroll = () => {
        const elements = document.querySelectorAll('.animate-element');
        elements.forEach(element => {
          if (isElementInViewport(element)) {
            element.classList.add('animate');
          }
        });
      };
      
      // Запуск при загрузке и при скролле
      window.addEventListener('load', handleScroll);
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Проверить сразу
    },
    handleResize() {
      this.showCurve = window.innerWidth > 768;
    }
  }
}
</script>


<style scoped>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* Контейнер для всей страницы с отступом */
.page-container {
  position: relative;
  max-width: 1200px;
  margin: 70px auto;
  padding: 0 20px;
}

.section-title{
  color: #505050;
  font-size: 36px;
  font-weight: 300;
  line-height: 48px;
  margin-bottom: 100px;
  text-align: center;
}

.features {
  display: flex;
  gap: 30px;
  margin: 50px auto;
  max-width: 1200px;
  justify-content: center;
  flex-wrap: wrap;
}

.feature-card {
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  border-radius: 8px;
  padding: 30px;
  flex: 1;
  min-width: 300px;
  max-width: 370px;
  min-height: 800px;
}

.feature-icon {
  width: 50px;
  height: 60px;
  border-radius: 50%;
  background: #16908e;
  justify-content: center;
  align-content: center;
  margin: 20px auto 30px ;
}

.feature-icon-other{
  width: 110px;
  height: 110px;
  border-radius: 50%;
  justify-content: center;
  align-content: center;
  margin: 0 auto 30px ;
}

.feature-block-img{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #16908e;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: auto;
  margin-bottom: 50px;
}

.feature-block-img-other{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: auto;
  margin-bottom: 50px;
}

.feature-card h3 {
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  margin-bottom: 15px;
  color: #333;
}

.feature-card p,
.feature-card ul {
  font-size: 14px;
  line-height: 1.6;
  color: #555;
  font-weight: 300;
  line-height: 30px;
  margin-bottom: 25px;
  list-style: none;
}

.feature-card ul {
  margin: 10px 0 15px;
}

.feature-card ul li {
  margin-bottom: 8px;
}

.download-link {
  display: inline-block;
  margin-top: 10px;
  color: teal;
  text-decoration: none;
  font-weight: bold;
}

.download-link:hover {
  text-decoration: underline;
}

/* ===== Silimed section ===== */

.silimed {
  text-align: center;
  margin: 0 auto;
  max-width: 1200px;
}

.silimed-banner{
  margin-bottom: 30px;
  padding: 5px;
  border: 1px solid rgba(15, 131, 129, .14);
}

.silimed-banner img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}

.silimed-buttons {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  gap: 40px;
  height: 100px;
  width: 100%;
}

.silimed-buttons a {
  color: #108381;
  font-size: 16px;
  font-weight: 200;
  line-height: 76px;
  position: relative;
  width: calc(33.333% - 28px);
  margin: 15px 0;
  padding: 0 15px;
  transition: .2s linear;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #0f8381;
  background: #fff;
}

.silimed-buttons a:hover {
  background: teal;
  color: #fff;
}

.silimed-text {
  max-width: 1160px;
  margin: 0 auto;
  text-align: left;
}

.silimed-text h2 {
  color: #0d1016;
  font-size: 30px;
  font-weight: 100;
  line-height: normal;
  margin-bottom: 25px;
}

.silimed-text p {
  font-weight: 300;
  line-height: 30px;
  margin-bottom: 25px;
  color: #555;
  font-size: 18px;
}

/* Анимационные стили */
.animate-element {
  transform: translateX(-100px);
  opacity: 0;
  transition: transform 0.8s ease-out, opacity 0.8s ease;
}

.animate {
  transform: translateX(0) !important;
  opacity: 1 !important;
}

/* Кривая линия - перемещена левее контента */
.curve-line {
  position: absolute;
  top: 0;
  left: -80px;
  width: 100px;
  height: 100%;
  z-index: -1;
}

.curve-svg {
  width: 100%;
  height: 100%;
}

.curve-path {
  fill: none;
  stroke: #0b8482;
  stroke-width: 2;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  transition: stroke-dashoffset 2s ease-in-out;
}

.animate-curve .curve-path {
  stroke-dashoffset: 0;
}

/* Адаптация для мобильных устройств */
@media (max-width: 768px) {
  .page-container {
    padding: 0 15px;
    margin: 40px auto;
  }
  
  .curve-line {
    display: none; /* Скрываем линию на мобильных */
  }
  
  .animate-element {
    transform: translateX(-50px); /* Меньшее смещение для мобильных */
  }
  
  .silimed-buttons {
    flex-direction: column;
    height: auto;
    gap: 15px;
  }
  
  .silimed-buttons a {
    width: 100%;
    line-height: 50px;
  }
  
  .features {
    flex-direction: column;
    align-items: center;
  }
  
  .feature-card {
    max-width: 100%;
    min-height: auto;
    margin-bottom: 30px;
  }
}
</style>